"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendTransaction = void 0;
const solana_utils_1 = require("@pythnetwork/solana-utils");
const sendTransaction = async (instructions, connection, wallet) => {
    const transactions = await solana_utils_1.TransactionBuilder.batchIntoVersionedTransactions(wallet.publicKey, connection, instructions.map((instruction) => ({
        instruction,
        signers: [],
    })), {});
    return (0, solana_utils_1.sendTransactions)(transactions, connection, wallet);
};
exports.sendTransaction = sendTransaction;
